import { useState, useEffect } from 'react';
import { sendRequest } from '../api/shootAPI';
import API from '../api/endpoints';

/**
 * Custom hook to fetch membership name by ID
 * @param {number} membershipId - The membership ID
 * @returns {string} The membership name or 'Free' if no membership
 */
export function useMembershipName(membershipId) {
  const [membershipName, setMembershipName] = useState('Free');

  useEffect(() => {
    const fetchMembershipName = async () => {
      if (membershipId) {
        try {
          const response = await sendRequest({
            method: 'get',
            url: API.WORKSPACE.membership(membershipId),
          });
          if (response.success && response.data) {
            setMembershipName(response.data.name);
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error fetching membership:', error);
          setMembershipName('Free');
        }
      } else {
        setMembershipName('Free');
      }
    };

    fetchMembershipName();
  }, [membershipId]);

  return membershipName;
}

export default useMembershipName;
